var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 258,
    viewBox: "0 0 258 258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 129,
    cy: 129,
    r: 129,
    fill: "#3199FA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 129,
    cy: 129,
    r: 108.469,
    fill: "#3199FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.449 126.136C175.449 136.006 167.451 144.011 157.574 144.011H99.7413C109.611 144.011 117.616 136.013 117.616 126.136V101.484C117.616 85.5147 130.564 72.5672 146.533 72.5672C162.502 72.5672 175.449 85.5147 175.449 101.484V126.136Z",
    fill: "#79D4F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8662 126.136C81.8662 136.006 89.8648 144.011 99.7413 144.011H157.574C147.705 144.011 139.699 136.013 139.699 126.136V79.3445C139.699 63.3755 126.752 50.428 110.783 50.428C94.8137 50.428 81.8662 63.3755 81.8662 79.3445V126.136Z",
    fill: "#0143E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.699 126.136V79.3445C139.699 77.3537 139.494 75.4052 139.113 73.5273C126.738 76.803 117.609 88.0774 117.609 101.484V126.136C117.609 136.006 109.611 144.011 99.7343 144.011H157.574C147.705 144.011 139.699 136.013 139.699 126.136Z",
    fill: "#3199FA"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.897 174.15H146.165C144.058 174.15 142.345 175.843 142.345 177.927C142.345 180.011 144.058 181.705 146.165 181.705H148.711V190.77C148.711 193.1 147.788 195.272 146.12 196.89C144.459 198.502 142.256 199.396 139.913 199.333L136.641 199.207C136.641 199.207 136.59 199.207 136.565 199.207C135.215 199.182 134.069 198.023 134.069 196.688V165.336C134.069 163.252 132.357 161.558 130.249 161.558C128.142 161.558 126.43 163.252 126.43 165.336V196.682C126.43 202.109 130.886 206.617 136.367 206.755L139.646 206.888C139.646 206.888 139.697 206.888 139.722 206.888C139.837 206.888 139.951 206.888 140.066 206.888C144.357 206.888 148.393 205.263 151.468 202.285C151.563 202.197 151.646 202.103 151.735 202.008C154.186 204.967 157.904 206.869 162.068 206.869H165.257C165.257 206.869 165.264 206.869 165.27 206.869C167.988 206.869 170.547 205.824 172.47 203.922C174.399 202.021 175.456 199.49 175.456 196.796V190.506C175.456 181.478 168.033 174.137 158.904 174.137L158.897 174.15ZM167.81 196.808C167.81 197.482 167.543 198.111 167.065 198.59C166.581 199.062 165.945 199.326 165.264 199.326H162.074C158.916 199.326 156.351 196.783 156.351 193.66V181.711H158.897C163.812 181.711 167.81 185.665 167.81 190.525V196.814V196.808ZM89.5056 190.519V196.814C89.5056 198.206 90.6452 199.333 92.0521 199.333H117.517C119.624 199.333 121.337 201.026 121.337 203.11C121.337 205.194 119.624 206.888 117.517 206.888H92.0521C86.4371 206.888 81.8662 202.367 81.8662 196.814V190.519C81.8662 181.491 89.2892 174.15 98.4183 174.15H117.517C119.624 174.15 121.337 175.843 121.337 177.927C121.337 180.011 119.624 181.705 117.517 181.705H98.4183C93.5036 181.705 89.5056 185.658 89.5056 190.519Z",
    fill: "#3199FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.517 169.113C117.269 169.113 117.02 169.088 116.772 169.038C116.53 168.993 116.288 168.918 116.059 168.824C115.824 168.729 115.607 168.616 115.397 168.477C115.187 168.339 114.99 168.181 114.818 168.005C114.639 167.835 114.48 167.64 114.34 167.432C114.207 167.231 114.086 167.01 113.99 166.784C113.895 166.551 113.818 166.312 113.774 166.072C113.723 165.833 113.697 165.581 113.697 165.336C113.697 164.341 114.105 163.371 114.818 162.666C115.703 161.785 117.02 161.382 118.262 161.634C118.504 161.678 118.746 161.753 118.975 161.848C119.21 161.942 119.433 162.062 119.637 162.194C119.847 162.333 120.044 162.49 120.216 162.666C120.394 162.843 120.554 163.031 120.694 163.239C120.827 163.447 120.948 163.661 121.044 163.894C121.139 164.121 121.209 164.354 121.26 164.599C121.311 164.838 121.337 165.09 121.337 165.336C121.337 165.581 121.311 165.833 121.26 166.072C121.209 166.312 121.139 166.551 121.044 166.784C120.948 167.01 120.827 167.231 120.694 167.432C120.554 167.64 120.394 167.835 120.216 168.005C120.044 168.181 119.847 168.339 119.637 168.477C119.433 168.616 119.21 168.729 118.975 168.824C118.746 168.918 118.504 168.993 118.262 169.038C118.02 169.088 117.765 169.113 117.517 169.113Z",
    fill: "#3199FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.46,
    height: 156.46,
    fill: "white",
    transform: "translate(50.4281 50.428)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.5833,
    height: 93.5833,
    fill: "white",
    transform: "translate(81.8662 50.428)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.5833,
    height: 45.3294,
    fill: "white",
    transform: "translate(81.8662 161.558)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyHero);
export default __webpack_public_path__ + "static/media/privacyHero.919865e050a8dd6e1271e24c35bca78f.svg";
export { ForwardRef as ReactComponent };